import { render, staticRenderFns } from "./ILPUnity.vue?vue&type=template&id=054198d7&scoped=true"
import script from "./ILPUnity.vue?vue&type=script&lang=js"
export * from "./ILPUnity.vue?vue&type=script&lang=js"
import style0 from "./ILPUnity.vue?vue&type=style&index=0&id=054198d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054198d7",
  null
  
)

export default component.exports